import { LocalizationConfig } from "../config/app";

//Campaign Store  state and functions
export default {
  state: {
    steps: {},
    campaign: {
      name: '',
      videos: [],
      perks: [],
      photos: [],
      'story-updates': [],
      comments: [],
      state: 'draft',
      student: { student: {} },
      education: {},
      statement: {}
    }
  },
  functions: {
    async reset() {
      const state = {
        steps: {},
        campaign: {
          name: '',
          videos: [],
          perks: [],
          photos: [],
          'story-updates': [],
          comments: [],
          state: 'draft',
          student: { student: {} },
          education: {},
          statement: {}
        }
      }
      this.setState({ campaign: state });
    },
    async initSteps(steps) {
      let state = this.state;
      state.campaign.steps = steps;
      this.setState(state);
    },
    async updateStepState(stepKey, stepState) {
      let state = this.state;
      state.campaign.steps[stepKey] = stepState;
      this.setState(state);
    },
    async updateCampaignState(campaign) {
      let state = this.state;
      state.campaign.campaign = campaign;
      this.setState(state);
    },
    async updateCampaignMainInfo(campaign) {
      let state = this.state;
      state.campaign.campaign.name = campaign.name;
      state.campaign.campaign.total_needs = campaign.total_needs;
      state.campaign.campaign.details = campaign.details;
      this.setState(state);
    },
    async updateVideos(videos) {
      let state = this.state;
      state.campaign.campaign.videos = videos;
      this.setState(state);
    },
    async updatePhotos(photos) {
      let state = this.state;
      state.campaign.campaign.photos = photos;
      this.setState(state);
    },
    async updateMilestones(milestones) {
      let state = this.state;
      state.campaign.campaign.milestones = milestones;
      this.setState(state);
    },
    async updatePerks(perks) {
      let state = this.state;
      state.campaign.campaign.perks = perks;
      this.setState(state);
    },
    async updateCampaignProp(prop, value) {
      let state = this.state;
      state.campaign.campaign[prop] = value;
      this.setState(state);
    },
    getStepState(id) {
      if (typeof (this.state.campaign.steps[id]) !== 'undefined')
        return this.state.campaign.steps[id];
      else return false;
    }
  }
}


